import { useToggle } from 'react-use'
import { useMediaQuery } from 'react-responsive'
import ConfirmModalContent from '@organs/ConfirmModalContent'
import { CloseOutlined } from '@ant-design/icons'
import { Wrapper } from './styled'

const RotateMobileBanner = () => {
  const landscape = useMediaQuery({ query: '(orientation: landscape)' })

  const [hidden, toggleHidden] = useToggle(false)

  if (hidden || landscape) return null

  return (
    <Wrapper>
      <ConfirmModalContent
        title="Внимание"
        leftIcon="success-bear-new.svg"
        rightContent="Для наиболее корректного отображения содержимого курсов поверните телефон горизонтально."
        iconSize={80}
      />
      <CloseOutlined onClick={toggleHidden} />
    </Wrapper>
  )
}

export default RotateMobileBanner
